module.exports = __webpack_public_path__ + "static/media/certify-edit-normal.fe9e972b.png";